'use client';

import type { CreateReviewBody } from '@api/models';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type ReviewItem, createReview } from '../services/reviews.service';

export function useCreateReview(activityId: string) {
  const queryClient = useQueryClient();

  return useMutation<ReviewItem, Error, CreateReviewBody>({
    mutationFn: (body) => createReview(activityId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reviews', activityId] });
      queryClient.invalidateQueries({ queryKey: ['activity', activityId] });
    }
  });
}
